"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createContentShareObserver = require("./createContentShareObserver");
Object.keys(_createContentShareObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createContentShareObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createContentShareObserver[key];
    }
  });
});